var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ModelCollection } from '../../Core';
import { ErrorCodes, ExceptionHandlerClass } from '../../System/Aop';
var ModelCollectionV5 = (function (_super) {
    __extends(ModelCollectionV5, _super);
    function ModelCollectionV5() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelCollectionV5.prototype.getModel = function (key) {
        if (this.models.containsKey(key)) {
            return this.models.value(key);
        }
        return null;
    };
    ModelCollectionV5.prototype.deleteCascade = function (key) {
        var model = this.getModel(key);
        if (model) {
            model['isDeleting'] = true;
            for (var propertyName in model) {
                if (this.isValidModelProperty(model, propertyName)) {
                    this.deleteDependants(model, propertyName);
                }
            }
            this.removedModels.push(key);
            this.models.remove(key);
        }
    };
    ModelCollectionV5.prototype.deleteDependants = function (model, propertyName) {
        propertyName = propertyName === 'Items' ? '_items' : propertyName;
        var propId = model[propertyName] ? model[propertyName].UniqueID : undefined;
        if (propId && !model['isDeleting']) {
            this.deleteCascade(propId);
        }
    };
    ModelCollectionV5 = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore)
    ], ModelCollectionV5);
    return ModelCollectionV5;
}(ModelCollection));
export { ModelCollectionV5 };
